<mat-dialog-content class="p-0 pt-4">
    <div class="has-bg p-5">
        <img alt="payhoa" class="logo" src="/assets/images/payhoa/marketing/payhoa-logo.png"/>
        <div class="row">
            <div class="col-md-6 offset-md-3 col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="p-3 text-center pb-4">
                            <img alt="stripe" class="strp" src="/assets/images/payhoa/dashboardEmpty/illustration.svg"/>
                        </div>

                        <p *ngIf="!data.account.currentDeadline" class="lead">Please complete a quick verification
                            process with Stripe</p>
                        <p *ngIf="data.account.currentDeadline" class="lead">KYC Requirements
                            Due {{ data.account.currentDeadline | legfiDate: 'MM/DD/YYYY' }}</p>

                        <p><b>Know Your Customer</b> regulations require us to gather information about our customers
                            when processing payments on their behalf. Please fill out the information below to receive
                            deposits into your bank accounts.</p>

                        <div class="gray-bg">
                            <div class="holder">

                                <img alt="security"
                                     class="strp d-md-inline-block d-none" src="/assets/images/payhoa/dashboardEmpty/security_icn.svg"/>

                                <p class="my-3">Your information is fully encrypted and is only used by our payment
                                    processor to
                                    verify your
                                    identity. Your data is never shared or sold. You can learn more about our security
                                    by
                                    clicking
                                    <a href="https://intercom.help/payhoa/en/articles/3482621-payhoa-security" target="_blank">here</a>.
                                </p>
                            </div>
                        </div>

                        <button [attr.aria-label]="'verify now'" (click)="verifyAccount()" class="button text-center text-white font-weight-bold btn-block">
                            Verify now
                            <mat-icon>launch</mat-icon>
                        </button>

                        <div class="text-center">
                            <button class="btn btn-link p-0" mat-dialog-close [attr.aria-label]="'verify later'" style="cursor: pointer">
                                I will do
                                verification later
                            </button>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</mat-dialog-content>
